import { CLIENTS_EDIT } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  onboardingConfigTypes: [],
  fetchOnboardingConfigTypesStatus: null,
  fetchOnboardingConfigTypes: null,
  clientOnboardingConfig: {},
  fetchClientOnboardingConfigStatus: null,
  fetchClientOnboardingConfigError: null,
  onboardingConfigsL1: [],
  fetchOnboardingConfigsL1Status: null,
  fetchOnboardingConfigsL1Error: null,
  onboardingConfigsL2: [],
  fetchOnboardingConfigsL2Status: null,
  fetchOnboardingConfigsL2Error: null,
  onboardingConfigsL3: [],
  fetchOnboardingConfigsL3Status: null,
  fetchOnboardingConfigsL3Error: null,
  client: {},
  fetchClientStatus: null,
  enableRealTimeApiStatus: null,
  disableRealTimeApiStatus: null,
  editClientStatus: null,
  editOnboardingConfigStatus: null,
  addOnboardingConfigStatus: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLIENTS_EDIT.UNSET:
      return {
        ...state,
        [action.payload.property || action.payload]: action.payload.value || null,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES:
      return {
        ...state,
        fetchOnboardingConfigTypesStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES_SUCCEEDED:
      return {
        ...state,
        onboardingConfigTypes: action.payload,
        fetchOnboardingConfigTypesStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES_FAILED:
      return {
        ...state,
        fetchOnboardingConfigTypesStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG:
      return {
        ...state,
        fetchClientOnboardingConfigStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG_SUCCEEDED:
      return {
        ...state,
        onboardingConfigs: action.payload,
        fetchClientOnboardingConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG_FAILED:
      return {
        ...state,
        fetchClientOnboardingConfigStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1:
      return {
        ...state,
        fetchOnboardingConfigsL1Status: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1_SUCCEEDED:
      return {
        ...state,
        onboardingConfigsL1: action.payload,
        fetchOnboardingConfigsL1Status: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1_FAILED:
      return {
        ...state,
        fetchOnboardingConfigsL1Status: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2:
      return {
        ...state,
        fetchOnboardingConfigsL2Status: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2_SUCCEEDED:
      return {
        ...state,
        onboardingConfigsL2: action.payload,
        fetchOnboardingConfigsL2Status: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2_FAILED:
      return {
        ...state,
        fetchOnboardingConfigsL2Status: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3:
      return {
        ...state,
        fetchOnboardingConfigsL3Status: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3_SUCCEEDED:
      return {
        ...state,
        onboardingConfigsL3: action.payload,
        fetchOnboardingConfigsL3Status: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3_FAILED:
      return {
        ...state,
        fetchOnboardingConfigsL3Status: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.FETCH_CLIENT:
      return {
        ...state,
        fetchClientStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.FETCH_CLIENT_SUCCEEDED:
      return {
        ...state,
        client: action.payload,
        fetchClientStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.FETCH_CLIENT_FAILED:
      return {
        ...state,
        fetchClientStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.ADD_ONB_CONFIG:
      return {
        ...state,
        addOnboardingConfigStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.ADD_ONB_CONFIG_SUCCEEDED:
      return {
        ...state,
        addOnboardingConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.ADD_ONB_CONFIG_FAILED:
      return {
        ...state,
        addOnboardingConfigStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.EDIT_ONB_CONFIG:
      return {
        ...state,
        editOnboardingConfigStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.EDIT_ONB_CONFIG_SUCCEEDED:
      return {
        ...state,
        editOnboardingConfigStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.EDIT_ONB_CONFIG_FAILED:
      return {
        ...state,
        editOnboardingConfigStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.EDIT_CLIENT:
      return {
        ...state,
        editClientStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.EDIT_CLIENT_SUCCEEDED:
      return {
        ...state,
        editClientStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.EDIT_CLIENT_FAILED:
      return {
        ...state,
        editClientStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.ENABLE_REAL_TIME_API:
      return {
        ...state,
        enableRealTimeApiStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.ENABLE_REAL_TIME_API_SUCCEEDED:
      return {
        ...state,
        client: {
          ...state.client,
          isRealTimeApiEnabled: true,
        },
        enableRealTimeApiStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.ENABLE_REAL_TIME_API_FAILED:
      return {
        ...state,
        enableRealTimeApisStatus: CONSTANTS.API.FAILED,
      };
    case CLIENTS_EDIT.DISABLE_REAL_TIME_API:
      return {
        ...state,
        disableRealTimeApiStatus: CONSTANTS.API.STARTED,
      };
    case CLIENTS_EDIT.DISABLE_REAL_TIME_API_SUCCEEDED:
      return {
        ...state,
        client: {
          ...state.client,
          isRealTimeApiEnabled: false,
        },
        disableRealTimeApiStatus: CONSTANTS.API.SUCCEEDED,
      };
    case CLIENTS_EDIT.DISABLE_REAL_TIME_API_FAILED:
      return {
        ...state,
        disableRealTimeApisStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
